document.addEventListener('DOMContentLoaded', () => {
  const hero = document.querySelector('.hero');

  if (!hero) return;

  const slides = hero.querySelectorAll('.hero__picture');

  if (slides.length <= 1) {
    if (slides[0]) slides[0].classList.add('is-active');
    return;
  }

  let current = 0;

  slides[current].classList.add('is-active');

  setInterval(() => {
    slides[current].classList.remove('is-active');

    current = (current + 1) % slides.length;

    slides[current].classList.add('is-active');
  }, 5000);
});